import AxiosWrapper, {
  axiosGetWithTokenHeader,
} from "../../../basecomp/base/AxiosWrapper";
import Logger from "../../../basecomp/base/Logger";

const Base_URL = process.env.REACT_APP_BE_URL;
const { axiosGetCallWithToken, axiosPostCallWithToken } = AxiosWrapper;

export const getDownloadExportFile = async (startDate, endDate ,selectedLocations) => {
  let response;
  try {
    response = await axiosGetWithTokenHeader(
      `${Base_URL}/label_print/getExportInventory?startDate=${startDate}&endDate=${endDate}&sloc=${JSON.stringify(selectedLocations)}`
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened. If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);
    throw sendError;
  }

  if (response === undefined) {
    throw new Error("No response");
  }

  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};
export const getDownloadMaterialExportFile = async (startDate, endDate ) => {
  console.log("logging date ");
  console.log(startDate,endDate);
  let response;
  try {
    response = await axiosGetWithTokenHeader(
      `${Base_URL}/label_print/getExportMaterialCounting?startDate=${startDate}&endDate=${endDate}`
    );
  } catch (error) {
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened. If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);
    throw sendError;
  }

  if (response === undefined) {
    throw new Error("No response");
  }

  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};
export const getDownloadStickerExportFile = async (startDate, endDate,materialNo,printedBy,putAwayBy,isPutawayPending ) => {
  console.log("logging date ");
  console.log(startDate,endDate);
  let time_zone= localStorage.getItem("time_zone")
  let response;
  try {
    response = await axiosGetWithTokenHeader(
      `${Base_URL}/label_print/getExportStickerPrint?time_zone=${time_zone}&startDate=${startDate}&endDate=${endDate}&material_no=${materialNo}&printed_by=${printedBy}&putaway_by=${putAwayBy}&pendingPutAway=${isPutawayPending}`
    );
  } catch (error) {
    

    if (error.response?.data instanceof Blob) {
    const text = await error.response.data.text();
    console.log("Blob text:", text);

    const json = JSON.parse(text);
    console.log("JSON:", json);
    console.log("Message:", json.message);
    throw json
    }
    let sendError = error;
    if (
      sendError.response !== undefined &&
      sendError.response.data !== undefined &&
      sendError.response.data.message !== undefined
    ) {
      sendError = new Error(sendError.response.data.message);
    } else {
      sendError = new Error(
        "Something unexpected happened. If the issue persists, please contact our support team for assistance."
      );
    }
    Logger.printStackTrace("Error fetching data:", error);
    throw sendError;
  }

  if (response === undefined) {
    throw new Error("No response");
  }

  if (response.status >= 200 && response.status <= 204) {
    if (
      response.data !== undefined &&
      response.data.status !== undefined &&
      response.data.status === 204
    ) {
      throw new Error(response.data.message);
    } else {
      return response;
    }
  }
};